<script lang="ts">
import cleanPhoneNumber from '@/utils/formatPhone';
import { defineComponent } from 'vue';
import { MaskInput } from 'vue-3-mask';

export default defineComponent({
  name: 'InputPhone',
  props: {
    phone: {
      type: String,
      required: true,
    },
  },
  components: {
    MaskInput,
  },
  emits: ['update:phone'],
  setup(props, { emit }) {
    const setPhone = (value: string) => {
      if (value.length === 15) {
        const formatPhone = '+55' + cleanPhoneNumber(value);
        emit('update:phone', formatPhone);
      }
    };
    return { setPhone };
  },
});
</script>

<template>
  <div class="form-group flex m-2 justify-center">
    <img src="@/assets/user.svg" class="w-6 mr-4" />
    <div class="relative">
      <MaskInput
        class="pl-10 p-2 bg-inherit border-2 border-blue-100 text-blue-500 focus-visible:border-blue-300 rounded-xl w-full"
        :v-model="phone"
        @input="setPhone($event.target.value)"
        mask="(##) #####-####"
        placeholder="(99) 99999-9999"
        inputmode="numeric"
      />
      <span
        class="absolute left-2 top-1/2 transform -translate-y-1/2 text-blue-500"
      >
        +55
      </span>
    </div>
  </div>
</template>
